import { useStore, State } from 'store';

import IAsync from 'types/IAsync';
import INodeAgent from 'types/INodeAgent';

export default function useNodesAsync(): IAsync<INodeAgent[]> {
  return useStore((state: State) => state.nodesAsync);
}
